import { looksLikePricing } from "@/lib/noPricing";

/**
 * Support & services as every surface shows it (spec 2026-10-15 §4.3–4.4).
 * Free text that reads as pricing is never shown: priced TC details drop the
 * details but keep the row; priced admin-assistance text drops the row. A
 * legacy `adminAssistance: true` still counts, with no details. Marketing-support
 * items are price-checked too: a priced item is dropped.
 */
export interface NormalizedSupport {
  transactionCoordinator: boolean;
  tcDetails: string | null;
  adminAssistance: boolean;
  adminDetails: string | null;
  marketingSupport: string[];
  isEmpty: boolean;
}

const shown = (v: unknown): string | null =>
  typeof v === "string" && v.trim() && !looksLikePricing(v) ? v.trim() : null;

export function normalizeSupport(pd: Record<string, any> | null | undefined): NormalizedSupport {
  const p = pd ?? {};
  const transactionCoordinator = p.hasTransactionCoordinator === true;
  const tcDetails = transactionCoordinator ? shown(p.tcDetails) : null;
  const adminDetails = shown(p.adminAssistance);
  const adminAssistance = p.adminAssistance === true || adminDetails !== null;
  const marketingSupport: string[] = Array.isArray(p.marketingSupport)
    ? [...new Set<string>(p.marketingSupport.filter((s: unknown): s is string => typeof s === "string" && !!s.trim() && !looksLikePricing(s)).map((s: string) => s.trim()))]
    : [];
  return {
    transactionCoordinator,
    tcDetails,
    adminAssistance,
    adminDetails,
    marketingSupport,
    isEmpty: !transactionCoordinator && !adminAssistance && marketingSupport.length === 0,
  };
}
